/**
 * Article type utilities
 */

/**
 * Article types that can be refreshed from their source URL.
 * URL articles are refreshed by re-scraping the webpage.
 */
export enum RefreshableArticleType {
  URL = 'URL',
}

/**
 * Check if an article type can be refreshed from its source URL.
 */
export const isRefreshableArticleType = (type: string): type is RefreshableArticleType =>
  Object.values(RefreshableArticleType).includes(type as RefreshableArticleType);

/**
 * Whether saving the current form edit opts a URL article out of account-level
 * auto-refresh (drives the "your edits stay put" save toast). True only on the
 * first real content/title edit of a watched URL article.
 */
export const editPausesAutoRefresh = (
  article:
    | { type: string; url: string | null; content_edited_manually_at: string | null }
    | undefined,
  dirtyFields: { content?: unknown; title?: unknown },
  settings: { enabled: boolean; available: boolean } | undefined,
): boolean =>
  !!article &&
  !!(dirtyFields.content || dirtyFields.title) &&
  isRefreshableArticleType(article.type) &&
  !!article.url?.trim() &&
  !article.content_edited_manually_at &&
  !!settings?.enabled &&
  settings.available;
